<script>
    import {createEventDispatcher} from 'svelte';
    import Button from "@cohesionib/biblioteca/lib/Button/Button.svelte";

    const dispatch = createEventDispatcher();
    const close = () => dispatch('close');

    let modal;

    const handle_keydown = e => {
        if (e.key === 'Escape') {
            close();
            return;
        }
    }
</script>

<style>

    @media only screen and (max-width: 1030px) {
        /* We need to adjust the position of the modal when the left nav bar is hidden */
        .modal {
            left: 50% !important;
        }
    }
    .modal-background {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.3);
        z-index: 10;
    }

    .modal {
        z-index: 10;
        position: fixed;
        /* For the positioning, we take into account the width of the left nav bar (220px / 2) and
        the height of the application header (80px / 2)*/
        left: calc(50% + 110px);
        top: calc(50% + 40px);
        max-width: 45em;
        max-height: 45em;
        overflow: auto;
        transform: translate(-50%,-50%);
        padding: 2em 1em;
        border-radius: 0.5em;
        background: white;
    }

    .button-wrapper {
        margin-top: 2em;
        height: 1.75em;
        width: 6em;
    }
</style>

<svelte:window on:keydown={handle_keydown}/>

<div class="modal-background" on:click={close}></div>

<div class="modal" role="dialog" aria-modal="true" bind:this={modal}>
    <slot name="header"></slot>
    <slot></slot>
    <div class="button-wrapper">
        <Button
            fillParent
            type="primary"
            onClick={close}>
            Close
        </Button>
    </div>
</div>
